<template>
	<div v-if="!loading">
    <div v-if="listOpen" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"></div>
		<p v-if="isOverviewPage" class="text-xl font-semibold pl-2.5 mb-2.5 mt-6 xl:pl-0">Faza grupowa - {{ leagueName }}</p>
		<div>
		<Transition name="fade-fast" mode="out-in">
			<div v-if="groupsToShow.length > 0 || Object.keys(groupsToShow).length > 0">
        <h2 v-if="showSelectGroup" class="!text-xl !font-semibold pl-2.5 !mb-[11px] underline !mt-6 xl:pl-0">
          <a class="flex flex-nowrap no-default-style items-center gap-x-2 cursor-pointer zt-hover"
             :href="'/wyniki-pilka-nozna/swiat/euro/grupy/'">
            Grupy {{leagueName}}
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9803 14.9178L18.5232 7.45891L11.9803 0L10.9116 1.21822L15.6548 6.60402L3.75 6.60402V8.3138L15.6548 8.3138L10.9116 13.6996L11.9803 14.9178Z" fill="white"/>
              <path d="M1.49982 6.60547H0L0 8.31525H1.49982L1.49982 6.60547Z" fill="white"/>
            </svg>
          </a>
        </h2>
        <div v-if="selectedPhase === 'group'" class="border-zt-light">
          <div v-if="showSelectGroup" class="py-2 px-2 bg-zt-light-opacity rounded-t-zt border-zt-light border-x border-t">
            <div v-click-outside="clickOutside" class="relative w-full" ref="list" :class="[{ 'z-modal' : listOpen && window.size.desktop },
				      Object.keys(groups).length <= 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer']">
              <div @click="handleOpen"
                   class="w-full text-[13px] h-[38px] pl-[6px] pr-4 rounded-[8px] flex justify-center items-center border border-zt-light bg-zt-light-opacity">
                <Transition name="fade" mode="out-in">
                  <div :key="selectedEuroGroup" class="flex items-center gap-x-[6px] mx-auto">
                    <div class="text-xs">{{ selectedEuroGroup.replace('Group', 'Grupa') }}</div>
                  </div>
                </Transition>
                <svg :class="[{ 'rotate-180' : listOpen }, {'hidden' : Object.keys(groups).length <= 1}]" class="transition" width="9" height="6" viewBox="0 0 9 6"
                     fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M0.99875 0.083984L4.25 3.32815L7.50125 0.0839843L8.5 1.08273L4.25 5.33273L1.94762e-07 1.08273L0.99875 0.083984Z"
                      fill="white"/>
                </svg>
              </div>
              <template v-if="window.size.desktop">
                <Transition name="fade">
                  <div v-if="listOpen"
                       class="bg-[#283344] w-full max-h-[316px] overflow-y-auto absolute z-10 top-[44px] rounded-zt border border-zt-light shadow-zt xl:max-h-[304px]">
                    <div v-for="(option, index) in Object.keys(groups)" :key="option"
                         @click="changeOption(option)"
                         :class="{ 'border-b-0' : index === Object.keys(selectedEuroGroup).length - 1, '!bg-zt-light hover:!bg-zt-light' :  option === selectedEuroGroup}"
                         class="hover:bg-zt-light/35 bg-[#283344] cursor-pointer pl-[6px] result no-default-style text-[13px] border-zt-light py-2 h-[38px] border-b-[1px] flex items-center gap-x-[6px]">
                      <p class="name font-normal">{{ option.replace('Group', 'Grupa') }}</p>
                    </div>
                  </div>
                </Transition>
              </template>
              <template v-else-if="listOpen">
                <SuperbetsSelectMobile @changed-option="(option) => changeOption(option)" @close-modal="handleOpen()"
                                       :options="Object.keys(groups)" :selected-option="selectedEuroGroup" />
              </template>
            </div>
          </div>

					<div v-if="groupsToShow.length !== 0" v-for="(group, key, index) in groupsToShow" :key="key">
						<StandingsTable :group-title="getGroupTitle(key)"
                            :rounded-top="(onMainPage && window.size.mobile) || showSelectGroup ? false : index === 0"
                            :teams="group" :filters="['all']" :group="key.toString()" :details="league_details"
                            :highlighted-team="teamId"
                            :show-promotion="showPromotion"
                            :redirect-to-team="leagueId !== 480 && leagueId !== 743"
                            :league-id="leagueId"
                            :animate="animate"
                            :selected-teams-ids="[+selectedTeamId]"
                            :advanced-teams-ids="getAdvancedTeams(key)"
                            :sorting="false" no-footer variant="group" />
					</div>
          <div v-if="+leagueId === 34 || +leagueId === 32"
               class="pl-4 py-3 bg-zt-light/35 rounded-b-zt border-[1px] border-t border-zt-light">
            <div class="legend grid grid-cols-4 duration-500 legend-full max-h-[250px] xl:max-h-[180px] opacity-100">
              <div class="flex flex-col text-zt-more gap-y-2 text-xs col-span-4 xl:col-span-3">
                <span class="foot-tab-row-marked-blue relative before:top-[1px] before:!h-[14px] before:!rounded-zt before:!-left-2">
                  Awans - Mistrzostwa Świata (Awans)
                </span>
                <span class="foot-tab-row-marked-blue-variant relative before:top-[1px] before:!h-[14px] before:!rounded-zt before:!-left-2">
                  Awans - Mistrzostwa Świata (Baraże)
                </span>
                <span v-if="getTeamsWithPenalties(Object.values(groupsToShow)[0]).length !== 0 && window.size.mobile" v-for="team in getTeamsWithPenalties(Object.values(groupsToShow)[0])" class="relative !text-[10px]">
                  <template v-if="team.matches.length === getTeamMatches(team).length">
                      <svg class="absolute fill-zt-more w-2.5 h-2.5 !-left-3 top-[2px]" viewBox="0 0 32 32" width="20" height="20">
                        <path d="M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z"></path>
                        <path d="M20 24h-8v-2h2v-6h-2v-2h6v8h2z"></path><path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"></path>
                      </svg>
                      {{team.short_name?.length > 0 ? team.short_name : team.name }}: {{team.standings.penalties}} pkt.
                  </template>
                </span>
              </div>
              <div v-if="getTeamsWithPenalties(Object.values(groupsToShow)[0]).length !== 0 && window.size.desktop" class="flex flex-col text-zt-more !text-[10px] gap-y-2 text-xs col-span-2 xl:col-span-1">
                <template v-for="team in getTeamsWithPenalties(Object.values(groupsToShow)[0])">
                 <span v-if="team.matches.length === getTeamMatches(team).length" class="relative">
                  <svg class="absolute fill-zt-more w-2.5 h-2.5 !-left-3 top-[2px]" viewBox="0 0 32 32" width="20" height="20">
                    <path d="M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z"></path>
                    <path d="M20 24h-8v-2h2v-6h-2v-2h6v8h2z"></path><path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z"></path>
                  </svg>
                  {{team.short_name?.length > 0 ? team.short_name : team.name }}: {{team.standings.penalties}} pkt.
                  </span>
                </template>
              </div>
              <div class="col-span-4 text-zt-more text-[10px] mt-2 -ml-2">
                <span v-if="league_details[0].sort_column === 'goal_diff'">O kolejności decydują: Punkty > Bilans bramek</span>
                <span v-if="league_details[0].sort_column === 'direct_matches'">O kolejności decydują: Punkty > Bilans meczów bezpośrednich</span>
              </div>
            </div>
          </div>
					<div v-else class="grid grid-cols-4 pl-4 py-3.5 bg-zt-light/35 border border-zt-light relative"
               :class="{ 'rounded-b-zt': !onMainPage || window.size.desktop }">
						<div class="flex flex-col text-zt-more gap-y-2 text-xs col-span-4 xl:col-span-3">
            <span class="relative foot-tab-row-marked-blue before:top-[1px] before:!h-[14px] before:!rounded-zt before:!-left-2">
              Awans - faza pucharowa
            </span>
							<span v-if="leagueId === 4 || leagueId === 6"
                    class="relative foot-tab-row-marked-green before:top-[1px] before:!h-[14px] before:!rounded-zt
                           before:!-left-2">
              Klasyfikacja  drużyn z 3. miejsca
            </span>
						</div>
            <div class="col-span-4 text-zt-more text-[10px] mt-3.5 -ml-2"
                 v-if="league_details[0] && league_details[0].sort_column?.length > 0">
              <span v-if="league_details[0].sort_column === 'goal_diff' || selectedEuroGroup === 'z 3. miejsc'">
                O kolejności decydują: Punkty > Bilans bramek
              </span>
              <span v-else-if="league_details[0].sort_column === 'direct_matches'">
                O kolejności decydują: Punkty > Bilans meczów bezpośrednich
              </span>
            </div>
          </div>
				</div>
        <div v-if="window.size.mobile && onMainPage" class="text-zt-more text-xs underline cursor-pointer text-center mt-5"
             @click="thirdPlacesClassificationOpened = !thirdPlacesClassificationOpened"
             data-bs-toggle="collapse" data-bs-target="#third-places">
          KLASYFIKACJA DRUŻYN Z 3. MIEJSC
          <svg class="fill-zt-more inline transition-transform"
               :class="{ 'rotate-180': thirdPlacesClassificationOpened }"
               width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.69189 0.083984L5.58914 3.32815L9.4864 0.0839843L10.6836 1.08273L5.58914 5.33273L0.494695 1.08273L1.69189 0.083984Z"></path></svg>
        </div>
        <div v-if="window.size.mobile && onMainPage" class="border-zt-light mt-6 collapse" id="third-places">
          <div v-for="(group, key, index) in thirdPlaces" :key="key">
            <StandingsTable :rounded-top="index === 0" :teams="group" :filters="['all']" :group="key.toString()"
                            :details="league_details" :sorting="false" no-footer variant="group" />
          </div>
          <div class="grid grid-cols-4 pl-4 py-3 bg-zt-light/35 border rounded-b-zt border-zt-light">
            <div class="col-span-4 text-zt-more text-[10px] -ml-2">
              <span>O kolejności decydują: Punkty > Bilans bramek</span>
            </div>
          </div>
        </div>
			</div>
			<div v-else>
				<p :class="{ '!rounded-t-[0px]' : !roundedTopInfo }"
            class="text-xs text-zt-more text-center border border-zt-light rounded-zt font-normal w-full
				          -leading-[0.18px] bg-zt-light-full py-2.5">
					Brak informacji o grupach
				</p>
			</div>
		</Transition>
		</div>
	</div>
</template>

<script>
import StandingsTable from "../components/football_tables/StandingsTable.vue";
import SuperbetsSelectMobile from "../components/football_stats/blocks/SuperbetsSelectMobile.vue";
import utils_mixin from "../mixins/utils_mixin";
import football_mixin from "../mixins/football_mixin";

export default {
	name: 'FootballLeagueGroups',
	components: {SuperbetsSelectMobile, StandingsTable},
	inject: ['WP'],
  mixins: [utils_mixin, football_mixin],
  props: {
    extraLeagueId: Number,
    extraLeagueName: String,
    extraCountryName: String,
    extraCountryQueryName: String,
    extraMatchesAmount: Number,
    extraSeason: Number,
    extraLeagueType: String,
    roundedTop: {
      default: false,
      type: Boolean
    },
    placeholderName: String,
    showPromotion: {
      type: Boolean,
      default: true
    },
    roundedTopInfo: {
      type: Boolean,
      default: true
    },
    animate: {
      type: Boolean,
      default: true,
    },
    selectedTeamId: {
      type: Number,
    }
  },
	data() {
		return {
			data: [],
			loading: true,
      clickOutside: {
        handler: () => { this.listOpen = false; this.unblockScrolling(); },
        events: ['touchend', 'mouseup']
      },
			groups: [],
			league_details: [],
			selectedPhase: 'group',
      thirdPlacesClassificationOpened: false,
      selectedEuroGroup: 'Grupa D',
      listOpen: false,
      advancedTeams: [],
		}
	},
  computed: {
    leagueType() {
      if (this.extraLeagueType) {
        return this.extraLeagueType;
      }
      return this.$attrs.leagueType || 'league';
    },
    isOverviewPage() {
      if (!this.$attrs.isOverview) {
        return false;
      }
      return this.$attrs.isOverview === 'true';
    },
    leagueId() {
      if (this.extraLeagueId) {
        return this.extraLeagueId;
      }
      return +this.$attrs.leagueId;
    },
    teamId() {
      return +this.$attrs.teamId ?? null;
    },
    teams() {
      if (this.isOverviewPage) {
        return JSON.parse(this.$attrs.teams);
      }
      return [];
    },
    leagueName() {
      if (this.extraLeagueName) {
        return this.extraLeagueName;
      }
      return this.$attrs.leagueName;
    },
    countryName() {
      if (this.extraCountryName) {
        return this.extraCountryName;
      }
      return this.$attrs.countryName;
    },
    onMainPage() {
      return this.$attrs.onMainPage ?? false;
    },
    groupsToShow() {
      if ((this.onMainPage && window.size.mobile) || this.showSelectGroup) {
        let groupName = this.selectedEuroGroup.replace('Grupa', 'Group');
        return {
          [groupName]: this.groups[groupName],
        };
      }
      return this.groups;
    },
    thirdPlaces() {
      return {
        'z 3. miejsc': this.groups['z 3. miejsc'],
      };
    },
    showSelectGroup() {
      return this.$attrs.showSelectGroup ?? false;
    }
  },
	mounted() {
		axios
			.post(this.WP.ajaxUrl, {
				endpoint: 'api_get_league_groups',
				league_id: this.leagueId
			})
			.then(response => {
				this.groups = response.data.data.groups;
				if (this.groups === undefined) {
					this.groups = [];
					this.league_details = response.data.data.league;
					this.loading = false;
					this.removePlaceholder(this.$attrs.section);
					return;
				}
        if (this.groups && (this.leagueId === 4 || this.leagueId === 6)) {
          this.groups['z 3. miejsc'] = this.groups['Ranking of third-placed teams'];
          if (this.groups['z 3. miejsc'] === undefined) {
            let teams = [];
            Object.values(this.groups).forEach(group => {
              if (group !== undefined) {
                teams.push(group[2]);
              }
            })
            teams.sort((a, b) => {
              let diff = b.points - a.points;
              if (diff === 0) {
                diff = (parseInt(b.goals_for) - parseInt(b.goals_against)) - (parseInt(a.goals_for) - parseInt(a.goals_against));
              }
              return diff;
            });
            this.groups['z 3. miejsc'] = teams;
          }
          delete this.groups['Ranking of third-placed teams'];
        }
				this.league_details = response.data.data.league;
        this.advancedTeams = response.data.data.advanced_teams;
        if (this.advancedTeams && (this.leagueId === 4 || this.leagueId === 6)) {
          this.advancedTeams['z 3. miejsc'] = this.advancedTeams['Ranking of third-placed teams'];
          delete this.advancedTeams['Ranking of third-placed teams'];
        }
        if (this.showSelectGroup && this.teamId !== null) {
         let groups_ = Object.entries(this.groups);
         let index = groups_.findIndex(group => {
           return group[1].some(team => {
             return Number(team.team_id) === this.teamId;
           })
         });
         if (index !== -1) {
           this.selectedEuroGroup = groups_[index][0];
         }
        }
				this.loading = false;
				this.removePlaceholder(this.$attrs.section ?? this.placeholderName);
			});

    this.emitter.on('euro-group-changed', (groupName) => this.selectedEuroGroup = groupName);
	},
  methods: {
    getTeamsWithPenalties(teams) {
      return teams.slice().filter(team => {
        return team.standings.penalties !== 0;
      }).sort((a,b) => {
        let diff = a.penalties - b.penalties;
        if (diff !== 0) {
          return diff;
        } else {
          return a.name.localeCompare(b.name);
        }
      })

    },
    handleOpen() {
      this.listOpen = !this.listOpen;
      if (this.listOpen) {
        if (window.size.desktop) {
          let extraOff = WP.user.adminBar ? -32 : 0;
          const y = this.$refs.list.getBoundingClientRect().top + window.pageYOffset + extraOff - 150;
          this.blockScrolling();
          window.scrollTo({top: y, behavior: 'smooth'});
        } else {
          this.blockScrolling();
        }
      } else {
        this.unblockScrolling();
      }
    },
    changeOption(option) {
      this.selectedEuroGroup = option;
      this.listOpen = false;
      this.unblockScrolling();
    },
    getAdvancedTeams(key) {
      if (key !== 'z 3. miejsc' && this.advancedTeams['z 3. miejsc'] !== undefined) {
        return [...this.advancedTeams[key], ...this.advancedTeams['z 3. miejsc']]
      }
      return this.advancedTeams[key]
    },
    getGroupTitle(key) {
      if (key.toLowerCase().includes('group')) {
        return key.toLowerCase().replace('group', 'grupa');
      }
      return ((this.onMainPage && window.size.mobile) || this.extraLeagueId === 34) ? 'Drużyna' : '';
    }
  }
}
</script>

<style scoped>
.filtering-button-main,
.filtering-button-active {
	@apply uppercase text-xs text-zt-more cursor-pointer font-medium py-1 px-4 h-7 border border-zt-light rounded flex items-center justify-center;
}
.filtering-button-active {
	@apply text-white !bg-zt-light border-zt-light pointer-events-none;
}
.filtering-button-main {
	@apply whitespace-nowrap text-white;
}

.filtering-button-main:hover,.filtering-button-number:hover, .filtering-button-inactive:hover  {
	@apply bg-zt-light/35 border-zt-light;
}
.fade-fast-enter-active,
.fade-fast-leave-active {
	transition: all 0.3s ease;
}

.fade-fast-enter-from,
.fade-fast-leave-to {
	opacity: 0;
}
</style>